import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';

import TransferPopover from '../components/TransferPopover';
import {
  loadUserProfilesPartnership,
  clearUserProfilesPartnershipPages,
} from '../../../../../state/modules/userProfilesPartnerships/actions';

import { assignSmsConversation } from '../../../../../state/modules/smsConversations/actions';

import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  const partnershipId = storage.get(findStorageType(), 'partnershipId');
  const limit = 20;
  const order = 'updated_at.asc';
  const page = 1;

  const result = state.userProfilesPartnerships.getIn([
    'pages',
    partnershipId,
    order,
    limit,
    page,
  ]);

  const list = result
    ? result
        .map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['userProfilesPartnerships', x]),
              schema.userProfilePartnership,
              state.entities.toJS()
            ),
          };
        })
        .toArray()
    : [];

  return {
    page: page,
    limit: limit,
    order: order,
    partnershipId: partnershipId,
    list: list,
    total: state.userProfilesPartnerships.get('total'),
    isLoading: state.userProfilesPartnerships.get('isLoading'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partnershipId, page, limit, order, filter, cb) => {
      dispatch(
        loadUserProfilesPartnership(
          partnershipId,
          page,
          limit,
          order,
          filter,
          cb
        )
      );
    },
    clearPages: (partnershipId) => {
      dispatch(clearUserProfilesPartnershipPages(partnershipId));
    },
    assign: (partnershipId, smsConversationId, data, cb) => {
      dispatch(
        assignSmsConversation(partnershipId, smsConversationId, data, cb)
      );
    },
  };
};

const TransferPopoverContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TransferPopover);

export default TransferPopoverContainer;
